// @flow

import React, { Component } from 'react';
import { checkIE } from '../utils';
import type { Card } from './types';

type Props = {
  card: Card,
  turned: boolean,
  active: boolean,
  size: number,
  level: number,
  turnCard: (card: Card) => void,
  index: number,
};

type State = {
  fadeIn: boolean,
};

// creates classnames based on browser compatibility
const createClassNames = (internetExplorer, fadeIn, turned, active) => {
  const fadeClass = fadeIn
    ? 'memory-card memory-card--in'
    : 'memory-card memory-card--out';
  if (internetExplorer) {
    const frontFaceClass =
      turned || active
        ? 'memory-card__face-front-ie-in'
        : 'memory-card__face-front-ie-out';
    const backFaceClass =
      turned || active
        ? 'memory-card__face-back-ie-out'
        : 'memory-card__face-back-ie-in';
    const flippedClass = 'memory-card__wrapper-ie';
    return { fadeClass, flippedClass, frontFaceClass, backFaceClass };
  }
  const frontFaceClass = 'memory-card__face-front';
  const backFaceClass = 'memory-card__face-back';
  const flippedClass =
    turned || active
      ? 'memory-card__wrapper is-flipped'
      : 'memory-card__wrapper';
  return { fadeClass, flippedClass, frontFaceClass, backFaceClass };
};

class MemoryCard extends Component<Props, State> {
  constructor(props: Props): void {
    super(props);

    this.state = {
      fadeIn: false,
    };
  }

  fadeIn(): void {
    this.setState({
      fadeIn: true,
    });
  }

  fadeOut(): void {
    this.setState({
      fadeIn: false,
    });
  }

  componentDidUpdate(prevProps: Props): void {
    if (this.props.level !== prevProps.level) {
      this.fadeOut();
    }
  }

  componentDidMount(): void {
    setTimeout(() => this.fadeIn(), 1000);
  }

  render(): React$Element<any> {
    const {
      assetPath,
      card,
      turned,
      active,
      turnCard,
      index,
      size,
    } = this.props;
    const { fadeIn } = this.state;
    const fadeDelay = `${index * 100}ms`;
    const backfaceBackground = {
      backgroundImage: `url('${assetPath}assets/games/memory_game/question_mark.svg'), linear-gradient(90deg, rgb(251, 198, 34) 0%, rgb(254, 217, 49) 100%)`,
    };

    const internetExplorer = checkIE();

    const cardClasses = createClassNames(
      internetExplorer,
      fadeIn,
      turned,
      active,
    );

    return (
      <div
        className={cardClasses.fadeClass}
        style={{
          transitionDelay: fadeDelay,
          width: size,
          height: size,
        }}
        onTransitionEnd={() => this.fadeIn()}
      >
        <div className={cardClasses.flippedClass}>
          <div
            className={`memory-card__face ${cardClasses.frontFaceClass}`}
            onClick={() => turnCard(card)}
          >
            <img src={card.imageUrl} alt={card.imageUrl} />
          </div>
          <div
            className={`memory-card__face ${cardClasses.backFaceClass}`}
            style={backfaceBackground}
            onClick={() => turnCard(card)}
          />
        </div>
      </div>
    );
  }
}

export default MemoryCard;
